import { gql } from "@apollo/client";

export const GET_EXISTE_PERIODO_ACTIVO = gql`
query existePeriodoActivo {
    existePeriodoActivo 
}`;